import styled from "styled-components";
import CloseIcon from "../icon/closeIcon";
import { useEffect, useState } from "react";
import { roomDataList } from "../../types/types";
import { Image } from "../common/image";
import CustomButton from "../common/customButton";
import { text } from "stream/consumers";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 60vw;
  height: 76vw;
  background-color: white;
  position: fixed;
  border-radius: 1vw;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 52vw;
  height: 66vw;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 6vw;
`;

const Contents = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50vw;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 6vw;
`;

const Title = styled.div`
  width: 42vw;
  font-size: 3.2vw;
  font-weight: 600;
  display: flex;
  align-items: center;
`;

const CloseBox = styled.div`
  width: 5vw;
  height: 5vw;
  border-radius: 0.6vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f2f2f2;
  &&:hover {
    cursor: pointer;
  }
`;

const RoomSelection = styled.div<{
  index: number;
  $selectedRoom?: number;
}>`
  width: 25.3vw;
  height: 11vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 600;
  background-color: #f2f2f2;
  border-radius: 0.6vw;
  outline: ${(props) =>
    props.$selectedRoom === props.index ? "2px solid #ff7f3b" : "none"};
`;

const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5vw;
  height: 5vw;
  background-color: #ff7f3b;
  border-radius: 100%;
`;

const NameBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12vw;
  height: 6vw;
  font-size: 2.6vw;
  margin-left: 1vw;
`;

const NameInputBox = styled.div<{
  $isSelected: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12vw;
  height: 5vw;
  border-radius: 0.4vw;
  /* outline: 0.2vw solid #c0c0c0; */
  outline: ${(props) =>
    props.$isSelected ? "0.2vw solid black" : "0.2vw solid #c0c0c0"};
  background-color: white;
  margin-left: 1vw;
`;

const NameInput = styled.input<{
  $isSelected: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 100%;
  outline: none;
  border: none;
  font-size: 2vw;
`;

export default function AddSpaceModal(props: any) {
  const { addNewSpace, onClose } = props;
  const roomList = roomDataList;
  const [step, setStep] = useState(1);
  const [selectedRoom, setSelectedRoom] = useState(1);
  const [customSelected, setCustomSelected] = useState(false);
  const [customName, setCustomName] = useState("기타");

  const onClickNext = () => {
    setStep(step + 1);
  };

  const onClickOk = () => {
    if (!customSelected) {
      addNewSpace(
        roomList[selectedRoom - 1].type,
        roomList[selectedRoom - 1].typeName,
        roomList[selectedRoom - 1].name
      );
    } else {
      addNewSpace(
        roomList[selectedRoom - 1].type,
        roomList[selectedRoom - 1].typeName,
        customName
      );
    }
    onClose();
  };

  const selectRoom = (id: number) => {
    setSelectedRoom(id);
  };

  const onChangeCustom = (e: any) => {
    setCustomName(e.target.value);
  };

  useEffect(() => {
    if (selectedRoom === 8) {
      setCustomSelected(true);
    } else {
      setCustomSelected(false);
    }
  }, [selectedRoom]);

  return (
    <Wrapper>
      {step === 1 && (
        <Container>
          <Header>
            <Title>추가할 공간을 선택하세요.</Title>
            <CloseBox>
              <CloseIcon onClick={onClose} height={"3vw"} fill={"#AEAEAE"} />
            </CloseBox>
          </Header>

          <Contents>
            {roomList.map((item: any) => {
              return (
                <RoomSelection
                  key={item.id}
                  index={item.id}
                  onClick={() => selectRoom(item.id)}
                  $selectedRoom={selectedRoom}
                >
                  <ImageBox>
                    <Image
                      src={`/icon/enterprise${item.type}.png`}
                      alt="아이콘"
                      width={"50%"}
                      height={"50%"}
                    />
                  </ImageBox>
                  {item.typeName === "custom" ? (
                    <NameInputBox $isSelected={customSelected}>
                      <NameInput
                        $isSelected={customSelected}
                        placeholder="기타"
                        onChange={(e) => onChangeCustom(e)}
                      ></NameInput>
                    </NameInputBox>
                  ) : (
                    <NameBox>{item.name}</NameBox>
                  )}
                </RoomSelection>
              );
            })}
          </Contents>
          <Footer>
            <CustomButton
              onClick={onClose}
              text={"취소"}
              size="2.4vw"
              $bgColor="none"
              color="black"
              $border="0.2vw solid black"
              height="100%"
              width="25.3vw"
            ></CustomButton>
            <CustomButton
              onClick={onClickOk}
              text={"확인"}
              size="2.4vw"
              height="100%"
              width="25.3vw"
              disabled={false}
            ></CustomButton>
          </Footer>
        </Container>
      )}
    </Wrapper>
  );
}
